import { render } from "./CgtAllocationModalPopup.vue?vue&type=template&id=25545952&scoped=true"
import script from "./CgtAllocationModalPopup.vue?vue&type=script&lang=js"
export * from "./CgtAllocationModalPopup.vue?vue&type=script&lang=js"

import "./CgtAllocationModalPopup.vue?vue&type=style&index=0&id=25545952&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25545952"]])

export default __exports__